// Copyright (c) 2023 Deere & Company

import t from 'tcomb';

const QuestionablePartSearch = t.struct({
    branch: t.maybe(t.String),
    language: t.maybe(t.String),
    masterWarrantytype: t.maybe(t.String),
    material:  t.maybe(t.String),
    modelnumber:  t.maybe(t.String),
    prodhierarchy:  t.maybe(t.String),
    questDesc:  t.maybe(t.String),
    wtyClmType: t.maybe(t.String),
}, {
    name: 'QuestionablePartSearch',
    strict: true
});

export const getDefaultState = () => new QuestionablePartSearch({});

export default QuestionablePartSearch;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/questionable-part-search.js